<template>
    <div>
        <div class="app-title">
            <div>
                <h2>{{$t('tlt.location.tree')}}</h2>
                <ul class="app-breadcrumb breadcrumb">
                    <li class="breadcrumb-item"><router-link to="/"><i class="fa fa-home"></i></router-link></li>
                    <li class="breadcrumb-item"><router-link to="/master/location"><span>{{$t('tlt.location')}}</span></router-link></li>
                    <li class="breadcrumb-item"><router-link to="/master/location/tree"><span>{{$t('lbl.location.tree')}}</span></router-link></li>
                </ul>
            </div>
        </div>
        <section class="app-content">
            <div :style="{height:height,width:width}" id="chartBody"></div>
        </section>
    </div>
</template>

<script>
// import locationModel from "./location.json";
export default {
    name: "locationTree",
    props: {
        optionSet: {
            type: Object
        },
        width: {
            type: String,
            default: '100%'
        },
        //图表高度设置
        height: {
            type: String,
            default: '600px'
        }
    },
    methods: {
        getParam() {
            return this.$route.query.locationModel;
        },
        drawChart() {
            var dom = document.getElementById("chartBody");
            var myChart = this.$echarts.init(dom);
            var locationModel = this.getParam();
            console.log(locationModel);
            myChart.clear();
            // myChart.showLoading();
            myChart.setOption({
            tooltip: {
                trigger: 'item',
                triggerOn: 'mousemove'
            },
            series:[
            {
                type: 'tree',

                data: [locationModel],

                left: '7%',
                right: '20%',
                top: '1%',
                bottom: '1%',

                symbol: 'emptyCircle',

                // orient: 'vertical',

                expandAndCollapse: true,

                label: {
                    normal: {
                        position: 'left',
                        // rotate: 0,
                        verticalAlign: 'middle',
                        align: 'right',
                        fontSize: 14
                    }
                },

                leaves: {
                    label: {
                        normal: {
                            position: 'right',
                            // rotate: -90,
                            verticalAlign: 'middle',
                            align: 'left'
                        }
                    }
                },

                animationDurationUpdate: 750
            }
        ]
            });
        }
    },
    mounted() {
        this.drawChart();
  }
}
</script>